import e from "react";
var t = "LiveIndicator-module_live_tag__kdJRY",
  n = "LiveIndicator-module_live_tag_text__Egr0a";
!function (e, t) {
  void 0 === t && (t = {});
  var n = t.insertAt;
  if (e && "undefined" != typeof document) {
    var i = document.head || document.getElementsByTagName("head")[0],
      a = document.createElement("style");
    a.type = "text/css", "top" === n && i.firstChild ? i.insertBefore(a, i.firstChild) : i.appendChild(a), a.styleSheet ? a.styleSheet.cssText = e : a.appendChild(document.createTextNode(e));
  }
}('.LiveIndicator-module_live_tag__kdJRY {\n  display: inline-block;\n  position: relative;\n  border-radius: 50%;\n  width: 5px;\n  height: 5px;\n  background-color: #da291c;\n  animation: LiveIndicator-module_blinker__eZVrU 1s cubic-bezier(0.5, 0, 1, 1) infinite alternate;\n  top: -2px;\n  margin-left: 1px;\n  margin-right: 4px;\n}\n.LiveIndicator-module_live_tag__kdJRY .LiveIndicator-module_live_tag_text__Egr0a {\n  margin-left: 4px;\n}\n\n.LiveIndicator-module_live_tag_text__Egr0a {\n  color: #da291c;\n  font-family: "protipo-narrow";\n  font-size: 12px;\n  font-weight: 500;\n}\n\n@keyframes LiveIndicator-module_blinker__eZVrU {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}');
var i = function i() {
  return e.createElement(e.Fragment, null, e.createElement("i", {
    className: t
  }), e.createElement("span", {
    className: n
  }, "LIVE"));
};
export { i as LiveIndicator, i as default };